import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import {
  BORDER_COLOR,
  BORDER_COLOR_2,
  HIRAGINO_FONT,
  SERVICE_COLOR,
  SERVICE_COLOR_3,
  SERVICE_DARK,
  SERVICE_LIGHT,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from './variables';
import red from '@material-ui/core/colors/red';

export const MuiAutoComplete = {
  listbox: {
    // Make background color on full matched options transparent
    '& [aria-selected="true"]:not([data-focus="true"])': {
      backgroundColor: 'transparent',
    },
  },
};

export const servicePaletteOptions = {
  primary: {
    light: SERVICE_LIGHT,
    main: SERVICE_COLOR,
    dark: SERVICE_DARK,
    contrastText: '#fff',
  },
  secondary: {
    light: red[300],
    main: red[500],
    dark: red[700],
  },
  action: {
    selected: 'rgba(0, 0, 0, 0.04)',
  },
  background: {
    default: '#fff',
  },
  text: {
    primary: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
  },
};

export const props = {
  palette: {
    primary: {
      light: SERVICE_LIGHT,
      main: SERVICE_COLOR,
      dark: SERVICE_DARK,
    },
  },
  text: {
    primary: {
      main: SERVICE_COLOR,
    },
  },
  backgroundColor: {
    primary: {
      main: SERVICE_COLOR_3,
    },
  },
  border: {
    primary: {
      main: BORDER_COLOR,
    },
    secondary: {
      main: BORDER_COLOR_2,
    },
  },
};

export const overrides = {
  MuiTypography: {
    root: {
      // Prevent the text from transformed to upper case
      textTransform: 'none',
    },
  },
  MuiButton: {
    root: {
      '& > *': {
        // Prevent the child element's event from triggered
        pointerEvents: 'none',
      },
    },
  },
};

export const serviceTheme = createMuiTheme({
  palette: servicePaletteOptions,
  overrides,
  props,
});

// For plan and business page
export const customTheme = createMuiTheme({
  palette: {
    text: {
      primary: TEXT_PRIMARY,
      secondary: TEXT_SECONDARY,
    },
  },
  shape: {
    borderRadius: 5,
  },
  typography: {
    fontFamily: HIRAGINO_FONT,
  },
  overrides,
  props,
});

export function makeBackgroundImageStyles(url, circle = false, other = {}) {
  return {
    backgroundImage: `url("${url}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    ...(circle && { borderRadius: '50%' }),
    ...other,
  };
}

export const makeTransformStyles = (value) => ({
  '-ms-transform': value,
  '-webkit-transform': value,
  transform: value,
});

export const makeTransitionStyles = (value) => ({
  '-ms-transition': value.replace('transform', '-ms-transform'),
  '-webkit-transition': value.replace('transform', '-webkit-transform'),
  transition: value,
});

export const makeScrollbarStyles = (
  theme,
  {
    width = theme.spacing(1),
    height = theme.spacing(1),
    backgroundColor = theme.palette.grey[700],
  } = {},
) => ({
  '&::-webkit-scrollbar': { width, height },
  '&::-webkit-scrollbar-thumb': { backgroundColor },
});

export const makeUserSelectStyles = (value) => ({
  '-moz-user-select': value,
  '-ms-user-select': value,
  '-webkit-user-select': value,
  userSelect: value,
});
